import { HTMLAttributes, ReactNode, Ref, forwardRef, memo } from 'react';
import s from './ScrollableContainer.module.scss';

type ScrollableContainerProps = {
  children: ReactNode;
  className?: string;
  scrollHeight?: string | number;
} & HTMLAttributes<HTMLDivElement>;

export const ScrollableContainer = memo(
  forwardRef<HTMLDivElement, ScrollableContainerProps>(
    (
      { children, className, scrollHeight, ...props },
      ref: Ref<HTMLDivElement>,
    ) => {
      return (
        <div
          ref={ref}
          style={{ ...props.style, height: scrollHeight }}
          className={`${s.scroll} ${className || ''}`}
          {...props}
        >
          {children}
        </div>
      );
    },
  ),
);

ScrollableContainer.displayName = 'ScrollableContainer';
